import { GridController, gridTpl } from '../../../../../common/grid/grid.controller';

class EquipmentCalibrationDetectorProbeGridController extends GridController {
    constructor($ngRedux, $state, NavigationService, EquipmentCalibrationActions, $filter) {
        super($ngRedux, $state, NavigationService);
        this.$ngRedux = $ngRedux;
        this.actions = EquipmentCalibrationActions;
        this.$filter = $filter;
    }

    $onInit() {
        this.module = 'equipmentCalibration';
        this.identifier = 'equipmentDetectorProbeGrid';
        this.autoload = true;
        this.filterComponent = false;
        this.exportComponent = false;

        this.columns = [
            {title: '#',                mapper: null},
            {title: 'Type',             mapper: 'asset_type_name'},
            {title: 'Category',         mapper: 'category_name'},
            {title: 'Manufacturer',     mapper: 'manufacturer_name'},
            {title: 'Model',            mapper: 'model_name'},
            {title: 'Serial Number',    mapper: 'serial'},
            {title: 'Radiation Type',   mapper: 'radiation_type_name'},
            {title: 'Due Date',         mapper: 'due_date'}
        ];

        this.unsubscribe = this.$ngRedux.connect(this.mapState().bind(this), this.actions)(this);
        this.dataAction = this.getAssets;

        this.init();
    }
}

EquipmentCalibrationDetectorProbeGridController.$inject = ['$ngRedux', '$state', 'NavigationService', 'EquipmentCalibrationActions', '$filter'];

export const equipmentCalibrationDetectorProbeGrid = {
    bindings: {
        title: '@',
        onSelect: '&',
        onRemove: '&'
    },
    controller: EquipmentCalibrationDetectorProbeGridController,
    ...gridTpl
};
